import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Container, Row, Col, Nav, Tab, Spinner } from 'react-bootstrap';
import { ProfileHeader } from '../Profile/ProfileHeader';
import FollowersList from '../Profile/FollowersList';
import { apiClient } from '../../services/api/apiClient';
import './public-profile-page.css';

interface PublicUser {
  _id: string;
  username: string;
  email?: string;
  profileImage?: string;
  bio?: string;
}

const PublicProfilePage: React.FC = () => {
  const { userId } = useParams<{ userId: string }>();
  const [user, setUser] = useState<PublicUser | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [socialTab, setSocialTab] = useState('followers');

  useEffect(() => {
    if (!userId) return;
    apiClient
      .get<PublicUser>(`/users/${userId}`)
      .then((res) => setUser(res.data))
      .catch((err) => setError(err.response?.data?.message || 'User not found'))
      .finally(() => setLoading(false));
  }, [userId]);

  if (loading) {
    return (
      <div className='public-profile-page__loading'>
        <Spinner animation='border' />
      </div>
    );
  }

  if (error || !user || !userId) {
    return (
      <div className='public-profile-page__error'>
        <p className='text-muted'>{error ?? 'User not found.'}</p>
        <Link to='/app/trips'>Back to My Trips</Link>
      </div>
    );
  }

  return (
    <div className='public-profile-page'>
      <Container>
        <ProfileHeader
          userId={userId}
          username={user.username ?? ''}
          bio={user.bio}
          profileImage={user.profileImage}
          showFollowButton={true}
        />

        <div className='mt-4'>
          <Tab.Container
            activeKey={socialTab}
            onSelect={(k) => setSocialTab(k || 'followers')}
          >
            <Nav
              variant='pills'
              className='mb-3'
            >
              <Nav.Item>
                <Nav.Link eventKey='followers'>Followers</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey='following'>Following</Nav.Link>
              </Nav.Item>
            </Nav>
            <Tab.Content>
              <Tab.Pane eventKey='followers'>
                <FollowersList
                  userId={userId}
                  type='followers'
                />
              </Tab.Pane>
              <Tab.Pane eventKey='following'>
                <FollowersList
                  userId={userId}
                  type='following'
                />
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      </Container>
    </div>
  );
};

export default PublicProfilePage;
